<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			label: string | ISbRichtext;
			subtext: string | ISbRichtext;
			assets: ISbStoryData[];
		}>['content'];
		stepNumber?: number;
	}

	let { content, stepNumber = 1 }: Props = $props();
</script>

<section use:editable={content} class="flex h-full flex-col justify-between text-brown-2">
	<div class="mb-4 lg:mb-6">
		<div
			class="mb-4 text-[40px]/[100%] font-semibold lining-nums tabular-nums tracking-[-.8px] text-orange-3 lg:mb-3 lg:text-[56px]/[100%] lg:tracking-[-1.12px]"
		>
			{stepNumber}
		</div>

		<h1 class="text-[24px]/[110%] font-semibold lg:text-[32px]/[110%] lg:tracking-[-.32px]">
			<SbRichtext text={content.label} />
		</h1>
		{#if content.subtext}
			<div class="mt-3 font-serif text-[16px]/[130%] tracking-[-.32px] lg:tracking-[-.4px]">
				<SbRichtext text={content.subtext} />
			</div>
		{/if}
	</div>
	<Blok content={content.assets[0]} />
</section>
